<script>
import { mapActions } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';

import AddEditForm from '@/components/redirects/AddEditForm';
import SingleView from '@/components/elements/views/SingleView';
import { StatusCodes, StatusCodesToRequired } from '@/enums/redirects';

export default {
    page: {
        title: 'Redirect'
    },

    components: {
        AddEditForm
    },

    extends: SingleView,

    validations: {
        item: {
            title: {
                required
            },
            from: {
                required
            },
            to: {
                required: requiredIf(function () {
                    return StatusCodesToRequired.includes(this.item.statusCode);
                })
            },
            statusCode: {
                required
            }
        }
    },

    data() {
        const { redirectId = null } = this.$route.params;

        return {
            backRoute: '/redirects',
            indexName: 'Redirects',
            singleItemName: 'redirect',
            preview: false,
            item: {
                id: redirectId,
                statusCode: StatusCodes.MOVED_PERMANENTLY
            }
        };
    },

    computed: {
        sections() {
            const sections = {
                permalink: false,
                meta: false
            };

            if (this.editMode) {
                sections.status = true;
            }

            return sections;
        }
    },

    methods: {
        ...mapActions({
            addItem: 'redirects/store',
            deleteItem: 'redirects/destroy',
            getItem: 'redirects/show',
            updateItem: 'redirects/update'
        })
    }
};
</script>
